import React from 'react';
import { AccordionLegacy, makeStyles } from '@applyboard/ui-components';
var useStyles = makeStyles({
  MuiAccordionroot: {
    position: 'inherit',
    paddingBottom: '15px',
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 0,
      paddingBottom: 0
    },
    '&.MuiAccordion-root:before': {
      backgroundColor: 'inherit'
    }
  }
});
var StyledAccordion = function StyledAccordion(_ref) {
  var expanded = _ref.expanded,
    onChange = _ref.onChange,
    children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(AccordionLegacy, {
    square: true,
    elevation: 0,
    classes: {
      root: classes.MuiAccordionroot
    },
    onChange: onChange,
    expanded: expanded,
    TransitionProps: {
      timeout: {
        enter: 400,
        exit: 200
      }
    }
  }, children);
};
export default StyledAccordion;